import { planTypes } from '@/common/constants';
import { flowTypes, pageConfig } from '@/common/service/page-config';
import { getPlanTypeByCategory } from '@/common/service/parse';
import { isZoomMeetingAsAddonCard } from '@/plans/ZOOM_MEETING/common/utils';

export const PLAN_TYPES_WITH_MULTI_BASE_PLANS = [planTypes.ROOM_CONNECTOR];

const ZoomRoomAsUrlBasePlanAndZoomMeetingAsBasePlan = () => {
  const { plan = 'pro' } = pageConfig;
  return isZoomMeetingAsAddonCard() && getPlanTypeByCategory(plan) === planTypes.ZOOM_ROOMS;
};

export const checkIfMultipleBasePlanDependencies = () => {
  const { type: pageFlowType } = pageConfig;
  return (
    // 0. Must buy flow
    (pageFlowType === flowTypes.basic2pro || pageFlowType === flowTypes.buyNow) &&
    // 1. [CRC] needs zoom room or zoom one as base plan, but zoom one prioritize than zoom room
    ZoomRoomAsUrlBasePlanAndZoomMeetingAsBasePlan()
  );
};
